import React, { useEffect, useState } from 'react';
import {
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	ResponsiveContainer,
} from 'recharts';
import { transformEventCountData } from '../utils/transformAPIResponse';
import { Box } from '@mui/material';

// Component to render the event count chart
const EventCountChart: React.FC<{
	apiResponse: AnalyticsApiResponse | null;
}> = ({ apiResponse }) => {
	const [eventCountData, setEventCountData] = useState<EventCountData[]>([]);

	useEffect(() => {
		if (!apiResponse) return;
		const transformedData = transformEventCountData(apiResponse);
		setEventCountData(transformedData);
	}, [apiResponse]);

	return (
		<Box sx={{ overflowX: 'auto', overflowY: 'hidden' }} mr={2}>
			<ResponsiveContainer width="100%" height={400} minWidth={1000}>
				<BarChart
					data={eventCountData}
					margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
				>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey="eventName" />
					<YAxis />
					<Tooltip />
					<Bar dataKey="eventCount" fill="#82ca9d" />
				</BarChart>
			</ResponsiveContainer>
		</Box>
	);
};

export default EventCountChart;
